module.exports = function(video) {
  "use strict";
	video
    .controller('livestreamController', livestreamController)

	livestreamController.$inject = ["$http", "$rootScope","$scope","getDataService","$state", "$stateParams","refreshtokenService","reqursiveService","putDataService","alertService","$timeout","postDataService","deleteDataService","serverError", "API_URL", "offlineError"];
	
  function livestreamController($http,$rootScope,$scope,getDataService,$state, $stateParams,refreshtokenService, reqursiveService, putDataService, alertService, $timeout, postDataService,deleteDataService,serverError, API_URL, offlineError) {
    var vmls = this;
    var validation = true;
    vmls.titleRequired = false;
    vmls.urlRequired = false;
    vmls.imgRequired = false;
    $rootScope.hasLoaded = true;
    var livestreamFunction = function(url) {
      var updateLivestreamData = {
        'title': vmls.title,
        'url': vmls.url,
        'image':vmls.imageSrc
      }
      if(vmls.active) {
        updateLivestreamData.active = 1;
      }else {
        updateLivestreamData.active = 0;
      }
      var putFunction = function() {
        $http.put(url , updateLivestreamData)
        .success(function (data, status, headers) {
            alertService('success','Success ', data.message, 2000);
            $rootScope.hasLoaded = true;
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(status ==502) {
            serverError();
          } else {  
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
           
          }
          $rootScope.hasLoaded = true;
        });
      }
      putFunction();
    }
    var getLivestreamFunction = function() {
      $rootScope.hasLoaded = false;
      getDataService.get({
          param1:'video',
          param2:'livestream',
        }).$promise.then(function(data){
          vmls.title = data.livestream.title;
          vmls.url = data.livestream.url;
          vmls.imageSrc = data.livestream.image;
          if(data.livestream.active==1) {
            vmls.active = true;
          }else {
            vmls.active = false;
          }
          $rootScope.hasLoaded = true;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getLivestreamFunction();
              }
              // do something
          },
          function(error) {
          },
          function(progress) {
              // report progress
          });
          } else if(error.status ==502) {
            serverError()
          } else if(error.status ==404) {
            scope.emptyTable = true;
        } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }    
        $rootScope.hasLoaded = true;  
      });
    }
    getLivestreamFunction();
    vmls.saveLivestream = function() {
      var validation = true;
      if(!vmls.title) {
        validation = false;
        vmls.titleRequired = true;
        alertService('danger','Opps! ', 'Title is required')
      } else {
        vmls.titleRequired = false;
      }
      if(!vmls.url) {
        validation = false;
        vmls.urlRequired = true;
        alertService('danger','Opps! ', 'URL is required')
      } else {
        vmls.urlRequired = false;
      }
      if(!vmls.imageSrc) {
        validation = false;
        vmls.imgRequired = true;
        alertService('danger','Opps! ', 'URL is required')
      } else {
        vmls.imgRequired = false;
      }
      if(validation) {
        $rootScope.hasLoaded = false;
        livestreamFunction(API_URL + 'video/livestream');
      }
    }
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  } 
}
  


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/livestream/js/livestreamController.js
// module id = 641
// module chunks = 0